export const TESTING = [
  {
    id: 1,
    label: "Tensile Bars",
    icon: "Minus",
  },
  {
    id: 2,
    label: "Chem Disks",
    icon: "Disc",
  },
  {
    id: 3,
    label: "Charpy Block",
    icon: "CreditCard",
  },
  {
    id: 4,
    label: "Welding Bar",
    icon: "CreditCard",
  },
];
